import { Component, ViewEncapsulation, input, signal } from "@angular/core";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ButtonDirective } from "primeng/button";
import { DatePicker } from "primeng/datepicker";
import { InputText } from "primeng/inputtext";
import { Popover } from "primeng/popover";
import { AbstractListController } from "src/app/common/abstract-list.component";

@Component({
  selector: "app-dynamic-filters",
  templateUrl: "./dynamic-filters.component.html",
  styleUrl: "./dynamic-filters.component.css",
  encapsulation: ViewEncapsulation.None,
  imports: [FormsModule, NgClass, NgTemplateOutlet, Popover, DatePicker, InputText, ButtonDirective],
})
export class DynamicFiltersComponent {
  readonly list = input.required<AbstractListController<any, any>>();

  readonly search = signal("");
  readonly adding = signal<any>(null);
  readonly editing = signal<any>(null);

  private static readonly TYPE_ICONS: Record<string, string> = {
    select: "pi-list",
    date: "pi-calendar",
    number: "pi-hashtag",
    string: "pi-search",
  };

  icon(col: any): string {
    return col.icon || DynamicFiltersComponent.TYPE_ICONS[col.type] || "pi-filter";
  }

  private hasValue(col: any): boolean {
    const v = this.list().filter(col.field);
    return v !== "" && v !== null && v !== undefined;
  }

  activeCols(): any[] {
    return this.list().colsFilter().filter((c) => this.hasValue(c));
  }

  availableCols(): any[] {
    const q = this.search().trim().toLowerCase();
    return this.list().colsFilter().filter((c) => !this.hasValue(c) && c.header.toLowerCase().includes(q));
  }

  value(col: any): any {
    return this.list().filter(col.field);
  }

  valueLabel(col: any): string {
    const v = this.value(col);
    if (col.type === "select") {
      return col.option?.find((o: any) => o.value === v)?.label ?? v;
    }
    return v;
  }

  pick(col: any, value: any, pop: { hide: () => void }): void {
    const list = this.list();
    list.setFilter(col.field, value ?? "");
    this.adding.set(null);
    pop.hide();
    list.page.set(1);
    list.loadItems();
  }

  remove(col: any): void {
    this.list().clearSingleFilter(col);
  }

  clear(): void {
    this.list().reset();
  }
}
